export default {
  // START:: GET APP LOCALE
  getAppLocale(state) {
    return state.printable_admin_dashboard_printablege;
  },
  // END:: GET APP LOCALE
};
